import React from "react";

const IMG = `${import.meta.env.BASE_URL}img/roulette`;

/**
 * Roulette (ourroullete / roulette11-13) winning-number overlay in the reference markup:
 *   .casino-video-cards > div > div > div > div > div > img({card}.png)
 * The reference's inner divs carry a literal `classname` attribute (a Vue typo), i.e. no class,
 * so they are plain divs here. Styled by `.roulette .casino-video-cards` in index.css.
 */
export default function RouletteCardsOverlay({ card }) {
  if (!card) return null;
  return (
    <div className="casino-video-cards">
      <div>
        <div>
          <div>
            <div>
              <div>
                <img src={`${IMG}/${card}.png`} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
